const isDeclined = payment => payment.status === 'declined'

const countDeclinedPayments = invoice => invoice.payments.filter(isDeclined).length

export default countDeclinedPayments
